// extracted by mini-css-extract-plugin
export default {"handler":"ZOtPS","reminderText":"chmvR"};